import styled from 'styled-components';
import { motion } from 'framer-motion';

export const AppContainer = styled.div`
  min-height: 100vh;
  background-color: var(--background-secondary);
  width: 100%;
  
  /* Mobile simulation styles */
  .mobile-simulation & {
    max-width: var(--mobile-sim-width, 375px);
    margin: 0 auto;
    border: 2px solid var(--border-color);
    border-radius: 0;
    overflow: hidden;
    position: relative;
    min-height: 100vh;
    box-shadow: 0 0 20px rgba(0,0,0,0.3);
  }
`;

export const MainContent = styled.main`
  display: flex;
  min-height: calc(100vh - 64px);
  
  @media (max-width: 768px) {
    min-height: calc(100vh - 56px);
  }
`;

export const ContentArea = styled.div`
  flex: 1;
  padding: 2rem;
  padding-bottom: calc(2rem + 110px + env(safe-area-inset-bottom));
  background-color: var(--background-secondary);
  width: 100%;
  
  @media (max-width: 599px) {
    padding: 1rem 0;
    padding-bottom: calc(1rem + 110px + env(safe-area-inset-bottom));
  }
  
  @media (min-width: 769px) {
    padding-bottom: calc(2rem + env(safe-area-inset-bottom));
  }
`;

export const AuthContainer = styled.div`
  min-height: 100vh;
  /* Keep cards centered in the visible viewport as mobile browser controls move. */
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Light mode: flat brand brown (--primary-color, #8C6B40). --primary-* stay
     gold in dark mode too, so override with a dark surface gradient under dark-mode
     (otherwise the dark auth card floats on a bright tan background). */
  background: var(--primary-color);
  padding: 1rem;

  body.dark-mode & {
    background: linear-gradient(135deg, #1A1714 0%, #2A2520 100%);
  }
`;

export const AuthCard = styled(motion.div)`
  background: var(--background-primary);
  border: 1px solid var(--border-color);
  border-radius: 18px;
  box-shadow: var(--shadow-md);
  padding: 2rem;
  width: 100%;
  max-width: 400px;
  
  @media (max-width: 768px) {
    border-radius: 16px;
  }
  
  @media (max-width: 480px) {
    padding: 1.5rem;
    border-radius: 14px;
  }
`;

export const Logo = styled.div`
  text-align: center;
  margin-bottom: 1.5rem;
  
  img {
    height: 60px;
    width: auto;
    margin-bottom: 0.75rem;
  }
  
  h1 {
    color: var(--primary-color);
    font-family: 'Cormorant Garamond', serif;
    font-size: 2rem;
    font-weight: 500;
    margin-bottom: 0.25rem;
    letter-spacing: -0.025em;
  }
  
  p {
    color: var(--text-secondary);
    font-size: 0.875rem;
    font-family: 'Inter', sans-serif;
    margin: 0;
  }
`;
